import { UserActivity } from './user-activity';

export class RoleUserActivity {
  constructor(
    public hash?: string,
    public role?: string,
    public userActivity?: UserActivity,
    public userActivityName?: string
  ) { }

  clone() {
    return new RoleUserActivity (
      this.hash,
      this.role,
      this.userActivity,
      this.userActivityName
    );
  }

  get userActivityHash() {
   return this.userActivity.hash;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/role-user-activity.ts